import Reveal from '@/components/base/Reveal';
import { relatedTopics } from '@/mocks/content';

export default function RelatedSection() {
  return (
    <section id="related" className="scroll-mt-16 bg-accent-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-center">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label tracking-widest uppercase text-accent-300">
                <span className="w-6 h-px bg-accent-400" />
                Related Topics
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                相关阅读方向
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-background-300">
                如果你喜欢《漂亮的保姆》这类作品，下面这些题材标签可以作为继续拓展阅读方向的参考，
                它们与本作在叙事风格或情感表达上都有相似之处。
              </p>
            </div>
            <div className="lg:col-span-7">
              <div className="flex flex-wrap gap-2 md:gap-3">
                {relatedTopics.map((topic) => (
                  <span
                    key={topic}
                    className="px-4 py-2 rounded-full border border-background-50/20 bg-background-50/5 text-sm text-background-100"
                  >
                    {topic}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}